import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    acceptedFormat: 'XML or CSV file',
    error:
      'An error occurred while uploading your file. Please try again in a few minutes and don’t hesitate to contact us if the error remains.',
    uploading: 'your document is being imported',
    uploadMessage: 'Drag and drop to upload or browse your files',
    uploadSuccess: 'File uploaded successfully!',
  },
  fr: {
    acceptedFormat: 'Format XML ou CSV',
    error:
      'Une erreur est survenue en ajoutant votre fichier. Essayez à nouveau dans quelques minutes et n’hésitez pas à nous contacter si le problème persiste.',
    uploading: 'Importation de votre document en cours',
    uploadMessage: 'Glissez votre document ou parcourez vos fichiers',
    uploadSuccess: 'Document ajouté avec brio !',
  },
} as const);
